import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AppState } from 'app/app.state';
import { ApiEndpointService } from 'app/core/services/api-endpoint.service';
import { HttpClientService } from 'app/core/services/http/http-client.service';
import { Observable } from 'rxjs';
import SafeUrlAssembler from 'safe-url-assembler';
import { EmailVerificationDialogComponent } from './email-verification-dialog.component';

@Injectable()
export class EmailVerificationDialogService {
    private dialogRef: MatDialogRef<EmailVerificationDialogComponent> | null = null;

    public constructor(
        private readonly dialog: MatDialog,
        private readonly appState: AppState,
        private readonly apiEndpointService: ApiEndpointService,
        private readonly httpClientService: HttpClientService,
    ) {
    }

    public open(): void {
        if (this.dialogRef) {
            return;
        }

        this.dialogRef = this.dialog.open(EmailVerificationDialogComponent, {
            width: '760px',
            maxWidth: 'calc(100vw - 32px)',
            data: {
                email: this.appState.user$()?.Email || '',
            },
        });

        this.dialogRef.afterClosed().subscribe(() => {
            this.dialogRef = null;
        });
    }

    public recordConfirmation(): Observable<unknown> {
        const endpoint = SafeUrlAssembler()
            .template(this.apiEndpointService.getEndpoint('verifyUserEmail'))
            .toString();

        return this.httpClientService.post(endpoint, null);
    }

    public markConfirmed(): void {
        const user = this.appState.user$();
        if (user) {
            this.appState.user$.set({ ...user, IsConfirmedEmail: true });
        }
    }
}